/**
 * Hamburg
 *
 * Attaches listeners to the Bootstrap collapse events. The listeners
 * will control the accordion colors that are set as data attributes.
 *
 * @author    Christopher Tousignant <christopher.tousignant@nichols.edu>
 * @package     Codevicious
 * @since       1.0.0
 */

import $ from 'jquery';
import 'headroom.js';

/**
 * Default export
 *
 * Exports a closure so the component automatically gets
 * attached to jQuery's prototype and can immediately
 * be consumed
 */
export default ( ( $ ) => {

    /**
     * Defaults to be used
     */
    let pluginName = 'hamburg',
        defaults = {};

    /**
     * Plugin Ctor
     *
     * @param element
     * @param options
     * @constructor
     */
    function Hamburg( element, options )
    {
        this.element =          element;
        this.$element =         $( element );
        this.options =          $.extend( {}, defaults, options );
        this._defaults =        defaults;
        this._name =            pluginName;

        this.$body =            $( 'body' );
        this.$hamburg =         $( this.$element.closest( '#hamburgNavigation' ) );
        this.$buttons =         $( this.$element.find( '.btn' ) );
        this.$panels =          $( this.$element.find( '.sub-menu' ) );
        this.activeBg =         $( this.$buttons[0] ).data( 'active-bg' );
        this.inactiveBg =       $( this.$buttons[0] ).data( 'inactive-bg' );
        this.activeColor =      $( this.$buttons[0] ).data( 'active-color' );
        this.inactiveColor =    $( this.$buttons[0] ).data( 'inactive-color' );

        this.init();
    }

    /**
     * Plugin Prototype
     */
    Hamburg.prototype =
    {
        init : function()
        {
            this.$panels.on( 'show.bs.collapse', this.active.bind( this ) );
            this.$panels.on( 'hide.bs.collapse', this.inactive.bind( this ) );
            this.$hamburg.on( 'show.bs.collapse', this.lockPage.bind( this ) );
            this.$hamburg.on( 'hide.bs.collapse', this.unlockPage.bind( this ) );
        },

        active : function( e )
        {
            e.stopPropagation();

            $.each( this.$buttons , ( index, button ) => {
                $( button ).removeClass( this.activeBg + " " + this.activeColor )
                    .addClass( this.inactiveBg + " " + this.inactiveColor );
            } );

            $( e.currentTarget ).prev( '.btn' ).removeClass( this.inactiveBg + " " + this.inactiveColor )
                .addClass( this.activeBg + " " + this.activeColor );
        },

        inactive : function( e )
        {
            e.stopPropagation();

            $( e.currentTarget ).prev( '.btn' ).removeClass( this.activeBg + " " + this.activeColor )
                .addClass( this.inactiveBg + " " + this.inactiveColor );
        },

        lockPage : function( e )
        {
            if( $( e.currentTarget ).attr( 'id' ) == 'hamburgNavigation' )
            {
                $( 'body' ).removeClass( 'hamburg-closed' ).addClass( 'hamburg-open' );

                if ( $( window ).innerWidth() > 767 )
                {
                    $( 'header' ).removeClass( 'headroom--pinned' ).addClass( 'headroom--unpinned' );
                }
                $( '#colophon' ).removeClass( 'headroom--pinned' ).addClass( 'headroom--unpinned' );
            }
        },

        unlockPage : function( e )
        {
            if( $( e.currentTarget ).attr( 'id' ) == 'hamburgNavigation' )
            {
                $( 'body' ).removeClass( 'hamburg-open' ).addClass( 'hamburg-closed' );

                if( $( window ).innerWidth() > 767 )
                {
                    $( 'header' ).removeClass( 'headroom--unpinned' ).addClass( 'headroom--pinned' );
                }
                $( '#colophon' ).removeClass( 'headroom--unpinned' ).addClass( 'headroom--pinned' );
            }
        },
    };

    $.fn[ pluginName ] = function( options )
    {
        /**
         * @todo fix if multiple hamburgs are used, they all get attached. No scope in arrow functions, can not use this
         */
        return this.each( () =>
        {
            if ( ! $.data( this, 'plugin_' + pluginName ) )
                $.data( this, 'plugin_' + pluginName , new Hamburg( this, options ));
        } );
    };

})( $.noConflict() );